/* ================================================== */
/* Scripts ========================================== */
/* ================================================== */

const $ = require('jquery');
const google_maps = require('./google-maps.js');
const woocommerce = require('./woocommerce.js');
const multibuy = require('./multibuy.js');
const doofinder = require('./doofinder.js');
const initHeroSliders = require('./modules/hero-slider.js');

require('@popperjs/core');
const bootstrap = require('bootstrap');
require('slick-carousel');
require('magnific-popup');

// Expose Bootstrap 5 on the window so other theme scripts can access
// bootstrap.Tooltip / Modal / etc. without each re-requiring the module.
window.bootstrap = bootstrap;
window.jQuery = $;

$(function () {
  google_maps.init_google_maps();
  woocommerce.init_woocommerce();
  multibuy.init_multibuy();
  doofinder.init_doofinder();
  magnific_init();
  mega_menu();
  slick_init();
  initHeroSliders();
  headerFix();
  adminBar();
  quickLinksAppend();
  dealCategories();
  shopCategoryNav();
  noticeBanner(0.075, '.notice-banner .slider-track');
  initTooltips();

  /* Bootstrap 5 tooltip init. Targets [data-bs-toggle="tooltip"] (not the
   * legacy Bootstrap 4 [data-toggle="tooltip"] attribute, which stays
   * inert). html: true lets short descriptions with <ul>/<li>/<p> tags
   * format correctly inside the popover. Bootstrap's default sanitiser
   * strips dangerous tags but keeps ul, li, p, strong, em, etc.
   *
   * Tooltips are made interactive — Bootstrap's default behaviour hides
   * the panel the moment the cursor leaves the trigger, which makes any
   * <a> inside the body unreachable. We add a 150ms hide delay (grace
   * window for the cursor to cross into the tip) and bind mouseenter /
   * mouseleave on the tip itself so it stays open while the cursor is
   * inside, and only closes once the cursor leaves the tip too. Any <a>
   * found inside is auto-decorated with .btn-underline-white so links
   * embedded by the client in the tooltip copy pick up theme styling
   * without requiring HTML edits in admin. */
  function initTooltips() {
    if (typeof window.bootstrap === 'undefined' || !window.bootstrap.Tooltip) {
      return;
    }
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (trigger) {
      if (window.bootstrap.Tooltip.getInstance(trigger)) return;

      var instance = new window.bootstrap.Tooltip(trigger, {
        html: true,
        delay: { show: 0, hide: 150 }
      });

      trigger.addEventListener('inserted.bs.tooltip', function () {
        var tipEl = instance.tip;
        if (!tipEl) return;

        // Decorate any embedded links with the theme underline style.
        tipEl.querySelectorAll('a').forEach(function (a) {
          if (!a.classList.contains('btn-underline-white')) {
            a.classList.add('btn-underline-white');
          }
        });

        // Avoid double-binding if Bootstrap reuses the same tip element.
        if (tipEl.dataset.acityInteractive === '1') return;
        tipEl.dataset.acityInteractive = '1';

        // Bootstrap 5.3's _leave() schedules hide() inside a timer that
        // bails when `_isHovered` is truthy. Calling instance.show() does
        // NOT clear that timer, which is why the tip closes the moment
        // the cursor leaves the trigger. Flipping _isHovered ourselves
        // makes the still-pending hide-callback skip — and on tip-leave
        // we flip it back and re-enter Bootstrap's _leave path so the
        // configured hide delay still runs.
        tipEl.addEventListener('mouseenter', function () {
          instance._isHovered = true;
        });
        tipEl.addEventListener('mouseleave', function () {
          instance._isHovered = false;
          instance._leave();
        });
      });
    });
  }

  function headerFix() {
    let header = $("header");
    let headerHeight = $(header).outerHeight();
    window.__headerHeight = headerHeight;
    $('body > main').css("margin-top", `${headerHeight}px`);

    // Publish a CSS variable for any element pinned below the header
    // (currently the mobile search bar — `.search-form-container--mobile`
    // sits at `top: var(--ac-header-h)` so it lands flush under the
    // mobile nav row instead of overlaying it). Includes the WP admin
    // bar height when present so the value reflects "where #header
    // ends in the viewport".
    let belowHeader = headerHeight;
    if ($('body').hasClass('admin-bar')) {
      belowHeader += $('#wpadminbar').outerHeight() || 32;
    }
    document.documentElement.style.setProperty('--ac-header-h', belowHeader + 'px');
  }

  /* Applies the "active" class to hyperlinks within the header */
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) { $(this).addClass("active"); }
  }); 

  /* Handles resize events */
  let resizeTimeout;
  $(window).on("resize", function () {
    mega_menu();
    headerFix(); 
    adminBar();
    dealCategories();
    shopCategoryNav();

    if($('#listTab').length > 0) {
      updateButtons();
    }

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(quickLinksAppend, 100);
  });

  /* Handles scroll events */
  $(window).on("scroll", function () {
    check_scroll();
  });

  /* Handles header offset when logged in */
  function adminBar() {
    if ($('body').hasClass('logged-in')) {
      var adminBarHeight = $('#wpadminbar').outerHeight() || 0;
  
      // Add admin bar height to the top position of the header
      $('header').css('top', adminBarHeight + 'px');
    }
  }

  /* Resolves a "#id" / "#name" hash to a target element and smooth-scrolls to
   * it, accounting for the fixed header and for targets that live inside a
   * collapsed (or display:none) Bootstrap accordion.
   *
   * Why this exists: a plain `target.offset().top` is wrong when the target is
   * hidden — jQuery returns 0 for a `display:none` element, so the page jumps to
   * the wrong place (the product page's Manufacturer Information panel is
   * rendered `display:none` and revealed by JS, and every accordion panel is
   * collapsed until opened). We therefore (a) expand the matching Bootstrap
   * collapse first so the target has a real position, then (b) measure the
   * offset only once it's actually visible, and (c) bail out instead of
   * scrolling to a bogus position if the target can't be resolved. */
  function acScrollToTarget(hash, animate) {
    if (!hash || hash === "#") return;

    var $target = $(hash.replace(/[^#\w-]/g, ""));
    if (!$target.length) {
      $target = $("[name=" + hash.slice(1) + "]");
    }
    if (!$target.length) return; // unknown target — don't scroll anywhere

    // If the target is (or lives inside) a Bootstrap collapse panel, open it so
    // it has a measurable position before we scroll. Scroll once it's shown.
    var $collapse = $target.closest(".accordion-collapse, .collapse");
    if ($collapse.length && !$collapse.hasClass("show") &&
        typeof bootstrap !== "undefined" && bootstrap.Collapse) {
      // Reveal a hidden accordion item (e.g. the display:none Manufacturer
      // Information section) so the panel can actually expand and be scrolled to.
      $collapse.closest(".accordion-item").css("display", "");

      $collapse.one("shown.bs.collapse", function () {
         acAnimateTo($target, animate);
      });
      bootstrap.Collapse.getOrCreateInstance($collapse[0]).show();
      return;
    }

     acAnimateTo($target, animate);
  }

  function acAnimateTo($target, animate) {
    if (!$target.length || !$target.is(":visible")) return; // never scroll to a hidden target
    var offset = $("header").outerHeight() || 0;
    var top = $target.offset().top - offset;
    if (animate === false) {
      $("html, body").scrollTop(top);
    } else {
      $("html, body").animate({ scrollTop: top }, 1000);
    }
  }

  /* Enables smooth scrolling on hyperlinks tagged with "smooth" class */
  $('a.smooth[href*="#"]').on("click", function (event) {
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = $target.length ? $target : $("[name=" + this.hash.slice(1) + "]");
      // Only intercept anchors whose target exists on this page; let everything
      // else fall through to the browser's default behaviour.
      if ($target.length || $(this.hash.replace(/[^#\w-]/g, "")).length) {
        event.preventDefault();
        acScrollToTarget(this.hash, true);
      }
    }
  });

  // Scroll on page load if hash exists.
  // Guard against hashes that aren't valid ID selectors (e.g. DooFinder layer
  // routes like "#4e6a/fullscreen-initial/") — feeding those to jQuery throws
  // "Syntax error, unrecognized expression" and breaks this handler.
  if (window.location.hash && /^#[A-Za-z][\w-]*$/.test(window.location.hash)) {
    // Delay the scroll to allow the page to fully render (and to let JS that
    // reveals hidden accordion items run first).
    setTimeout(function () {
      acScrollToTarget(window.location.hash, true);
    }, 100); // Adjust delay as needed
  }

  // Mobile menu toggle
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.addClass("open");
  });

  // Top-level title acts as the submenu toggle (clicking the label opens the
  // submenu instead of navigating). Forward the click to the chevron toggle.
  $(".submenu-title-toggle").on("click", function () {
    $(this).siblings(".submenu-toggle").first().trigger("click");
  });

  // Whole-li click target — anywhere on a mobile menu <li> that has a
  // submenu opens it, not just the chevron / title text. Scoped to
  // #navigation-mobile so this doesn't run on the desktop mega-menu
  // (which is hover-driven). Works for any depth: clicking Appliances
  // opens its submenu, then clicking Cooking inside that submenu opens
  // Cooking's submenu, and so on.
  //
  // Bails when the click landed on an element that already has its own
  // behaviour (links, buttons, the existing toggles), or when the click
  // landed inside this li's *own* open submenu (so clicking around in an
  // open submenu doesn't re-toggle the parent that owns it).
  $("#navigation-mobile").on("click", "li", function (e) {
    // The handler is delegated, so a click in a nested li bubbles up and
    // hits ancestor lis too. Run only when the click's nearest <li> is
    // the one we're handling — this is what makes deeper nested li
    // clicks open the deeper submenu without also triggering the parent.
    if (e.target.closest("li") !== this) return;

    // Skip clicks on anything that already does something on its own.
    if (
      $(e.target).closest(
        "a, button, input, select, textarea, .submenu-toggle, .submenu-title-toggle, .submenu-list-toggle, .back-btn"
      ).length
    ) {
      return;
    }

    // Skip clicks that landed inside this li's own .submenu (i.e. on
    // empty padding / non-interactive areas of an already-open submenu)
    // — clicking inside the open submenu shouldn't re-toggle this li.
    // Only the li's *own direct-child* .submenu is treated this way; a
    // click that's in an *ancestor*'s submenu (which is what every
    // nested li click looks like geometrically) still runs through.
    var $ownSubmenu = $(this).children(".submenu").first();
    if ($ownSubmenu.length && $.contains($ownSubmenu[0], e.target)) {
      return;
    }

    // Fire the direct-child chevron toggle if there is one.
    var $toggle = $(this).children(".submenu-toggle").first();
    if ($toggle.length) {
      $toggle.trigger("click");
    }
  });

  $(".submenu-list-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");

    // Find the sibling .submenu-list
    var submenu = toggle.siblings(".submenu-list");
    submenu.toggle(); // toggle visibility
  });

  $(".back-btn").on("click", function() {
    var currentItem = $(this);
    var submenu = currentItem.closest(".submenu");
    submenu.removeClass("open");
  });

  /* Triggering the burger menu upon click */
  $("#burger").on('click', function () {
    open = !open;
    menu_toggle(open);
  });

  /* Triggering a tag click on card click for nested a tags */
  $('.navigation-card').on('click', function(e) {
    // Ignore clicks on actual links or buttons inside
    if (!$(e.target).closest('a, button').length) {
      var $button = $(this).find('a').first();
      var url = $button.attr('href');
      var target = $button.attr('target') || '_self';

      if (url) {
        window.open(url, target);
      }
    }
  });

  // Mega-menu hover-intent. CSS-only :hover with transition-delay can't
  // be cancelled if the cursor leaves before the threshold, so a slow
  // mouse traversal across the nav row still pops the panel. We use a
  // dwell timer instead: the cursor must stay over the same parent for
  // 150ms before .is-mega-open is added (and the matching CSS rule
  // reveals the panel). Mouseleave clears the timer and the class.
  var MEGA_HOVER_INTENT_MS = 150;

  $('.mega-parent').each(function () {
    var $li = $(this);
    var openTimer = null;

    $li.on('mouseenter', function () {
      if (openTimer) {
        clearTimeout(openTimer);
      }
      openTimer = setTimeout(function () {
        $li.addClass('is-mega-open');

        // Activate the first tab on open if nothing is active yet —
        // moved here from a separate mouseenter handler so tab state
        // mirrors the visible-open state, not the raw hover.
        var $mega = $li.find('.mega-menu');
        if ($mega.length && !$mega.find('.menu-tab-nav.active').length) {
          var $firstTab = $mega.find('.menu-tab-nav').first();
          var dataTarget = $firstTab.data('tab-id');
          $firstTab.addClass('active');
          $mega.find('.menu-tab-content[data-tab-id="' + dataTarget + '"]').addClass('active');
        }
      }, MEGA_HOVER_INTENT_MS);
    });

    $li.on('mouseleave', function () {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
      $li.removeClass('is-mega-open');
    });

    // Returning to the top-level link from the panel (without leaving the
    // li) must reopen the panel, otherwise .mega-menu-closed sticks until
    // the cursor leaves the whole item.
    $li.on('mouseenter', '> a', function () {
      $li.removeClass('mega-menu-closed');
    });
  });

  $('.mega-menu').on('mouseenter', '.menu-tab-nav', function(){
    var $mega = $(this).closest('.mega-menu');
    const dataTarget = $(this).data('tab-id');

    $mega.find('.menu-tab-content').removeClass('active');
    $mega.find('.menu-tab-nav').removeClass('active');

    $mega.find('.menu-tab-content[data-tab-id="' + dataTarget + '"]').addClass('active');
    $(this).addClass('active');
  });

  $('.mega-menu').on('mouseleave', function(){
    $(this).find('.menu-tab-content').removeClass('active');
    $(this).find('.menu-tab-nav').removeClass('active');
  });

  // Close mega menu when mouse leaves the inner content area
  $('.mega-menu-inner').on('mouseleave', function(){
    $(this).closest('.mega-parent').addClass('mega-menu-closed');
  });

  $('.mega-parent').on('mouseleave', function(){
    $(this).removeClass('mega-menu-closed');
  });

  // Quick Links Toggle
  function quickLinksAppend() {
    // Loop through each brand-hero block
    $('.brand-hero').each(function() {
      var $heroBlock = $(this);
      
      // First, remove any duplicates within this hero block - keep only the first one
      var $allQuickLinks = $heroBlock.find('.quick-links');
      if ($allQuickLinks.length > 1) {
        $allQuickLinks.not(':first').remove();
      }
      
      var $quickLinks = $heroBlock.find('.quick-links').first();
      
      if (!$quickLinks.length) return; // skip this hero block if no quick-links found

      if ($(window).width() < 992) {
        // mobile - only move if not already in mobile container
        var $mobileContainer = $heroBlock.find('.quick-links-mobile-append .p-6');
        if ($mobileContainer.length && !$quickLinks.parent().is($mobileContainer)) {
          $quickLinks.detach().appendTo($mobileContainer);
        }
      } else {
        // desktop - only move if not already in desktop container
        var $desktopContainer = $heroBlock.find('.quick-links-desktop-append');
        if ($desktopContainer.length && !$quickLinks.parent().is($desktopContainer)) {
          $quickLinks.detach().appendTo($desktopContainer);
        }
      }
    });
  }

  $('.brand-hero .quick-links .quick-links-toggle').on('click', function(){
    $('.quick-links .inner-links').toggleClass('d-none d-flex');
    $(this).toggleClass('active');
  });

  $('.brand-quick-links .quick-links .quick-links-toggle').on('click', function(){
    $('.quick-links .inner-links').toggleClass('d-none d-flex');
    $(this).toggleClass('active');
  });
  

  if ($(window).width() >= 992) {  
    $('.quick-link-wrapper').on('mouseover', function() {
      $(this).find('.sub-links').addClass('active');
    }).on('mouseout', function() {
      $(this).find('.sub-links').removeClass('active');
    });
  } else {
    $('.sub-links-toggle').on('click', function() {
      $(this).closest('.quick-link-wrapper').find('.sub-links').toggleClass('active');
    });
  }

  // Video Play Button
  $('.btn-play-video').on('click', function() {
    var $videoContainer = $(this).closest('.video-container');
    var $video = $(this).closest('.video-container').find('video').get(0);
    var $icon = $(this).find('i');
    $videoContainer.toggleClass('active');

    if ($video) {
      if ($video.paused) {
        $video.play();
        $video.controls = true;
        $icon.removeClass('fa-play').addClass('fa-pause');
      } else {
        $video.pause();
        $video.controls = false;
        $icon.removeClass('fa-pause').addClass('fa-play');
      }
    }
  });

  $('form.woocommerce-form input[type="password"]').on('input', function() {
    let $parent = $(this).closest('.input-outer');
    let $wrapper = $(this).closest('span.password-input').first();

    if($wrapper.length > 0) {
      let $hint = $wrapper.siblings('.woocommerce-password-hint').first();
      let $strength = $wrapper.siblings('#password_strength').first();

      if($hint.length > 0) {
        $parent.append($hint);
      }

      if($strength.length > 0) {
        $parent.append($strength);
      }
    }
  });

  $('.deal-categories-container input[type="radio"]').on('change', function() {
    let $form = $(this).closest('form');
    $form.submit();
  })

  $('.promo-categories-container input[type="radio"]').on('change', function() {
    let $form = $(this).closest('form');
    $form.submit();
  })
  
  $('.promos-load-more').on('click', function() {
    var button = $(this);
    var container = button.closest('.promotion-cards');
    
    // Find hidden promotion cards
    var hiddenCards = container.find('.promotion-card:hidden');
    
    // Show next 3 cards
    hiddenCards.slice(0, 3).fadeIn(400);
    
    // Check if there are any more hidden cards
    var remainingCards = container.find('.promotion-card:hidden').length;
    
    // Hide the load more button if no more cards to show
    if (remainingCards === 0) {
      button.closest('.load-more-container').fadeOut(400);
    }
  });

// Search-form toggle (collapsed below xxl, expanded by `#search-toggle`)
// Container picks up `.is-open` which the SCSS uses to flip the form's
// display from none → flex. Document-delegated so it survives any
// header re-renders (mega-menu hover state changes etc.).
//
// The toggle button is rendered as a SIBLING of `.search-form-container`
// (not a descendant), so we resolve the container via these strategies
// in order:
//   1. ancestor — covers any future template variant where the toggle
//      lives inside the container
//   2. previous sibling — current `searchform.php` layout
//   3. first match in the document — last-resort fallback
function ac_findSearchContainer($toggle) {
  // Variant-aware mapping — two copies of the searchform exist (one
  // per breakpoint group), each with a `--variant` class.
  if ($toggle.is('.search-btn')) {
    var $mobile = $('.search-form-container--mobile').first();
    if ($mobile.length) return $mobile;
  }
  if ($toggle.is('#search-toggle')) {
    var $desktop = $('.search-form-container--desktop').first();
    if ($desktop.length) return $desktop;
  }
  // Fallbacks for older / cached templates that don't have variant classes.
  var $c = $toggle.closest('.search-form-container');
  if ($c.length) return $c;
  $c = $toggle.prevAll('.search-form-container').first();
  if ($c.length) return $c;
  $c = $toggle.nextAll('.search-form-container').first();
  if ($c.length) return $c;
  return $('.search-form-container').first();
}

// React's native value setter — bypassing the property setter is the
// only reliable way to push a value into an input AND have downstream
// listeners (DooFinder, our mirror) treat it as a real keystroke.
// Cached once at module scope so we don't rebuild it on every poke.
var ac_setNativeInputValue = (function () {
  var desc = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
  return desc && desc.set
    ? function (el, v) { desc.set.call(el, v); }
    : function (el, v) { el.value = v; };
})();

// Open the DooFinder Live Layer programmatically.
//
// DooFinder ONLY opens the layer in response to a value-change input
// event on its bound input — focus, click, and hash changes from a
// cold state are all ignored. We poke the value to ' ' (space) →
// dispatch input → poke back to '' → dispatch input. DooFinder ends
// in `fullscreen-initial` (empty query) state, no visible flicker.
//
// Reliability fixes vs. the previous inline version:
//   1. Pokes BOTH the variant-specific visible input the user sees
//      (e.g. `#df-search-mobile`) AND the bound `#df-search`. The
//      `mirrorSearchInput` listener in doofinder.js usually forwards
//      visible→bound, but if DooFinder hasn't initialised yet the
//      mirror returns false and the layer never opens.
//   2. Native focus on the visible input — `jQuery.trigger('focus')`
//      sometimes doesn't move real focus on display:none-parent
//      inputs.
//   3. Watchdog retries — `.dfd-animate` is the most reliable
//      "layer is currently open" class on `.dfd-root` (gets added
//      whenever DooFinder transitions the layer in). If the form is
//      `.is-open` but `.dfd-root` doesn't carry `.dfd-animate` after
//      the poke, the layer hasn't mounted — re-poke up to a few
//      times spaced out to cover cold-start races.
function ac_isLayerOpen() {
  var root = document.querySelector('.dfd-root');
  return !!(root && root.classList.contains('dfd-animate'));
}

function ac_openDoofinderLayer($visibleInput) {
  if (!$visibleInput) return;

  // Native focus on the visible input.
  try { $visibleInput.focus(); } catch (e) {}

  // If the layer is already open, nothing else to do.
  if (ac_isLayerOpen()) return;

  function pokeOnce() {
    var bound = document.getElementById('df-search');
    var inputs = [];
    if (bound) inputs.push(bound);
    if ($visibleInput && $visibleInput !== bound) inputs.push($visibleInput);

    inputs.forEach(function (el) {
      var prev = el.value;
      ac_setNativeInputValue(el, ' ');
      el.dispatchEvent(new Event('input', { bubbles: true }));
      ac_setNativeInputValue(el, prev);
      el.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  pokeOnce();

  // Watchdog: re-check the layer state at increasing intervals. If
  // the form claims `.is-open` but the layer hasn't picked up
  // `.dfd-animate`, the poke didn't take — fire it again. Stop as
  // soon as the layer responds, or after the last attempt.
  var attempts = [150, 400, 900];
  attempts.forEach(function (delay) {
    setTimeout(function () {
      if (ac_isLayerOpen()) return;
      // Bail if the form has been closed in the meantime — no point
      // forcing the layer back open against the user's intent.
      var $openForm = $('.search-form-container.is-open');
      if (!$openForm.length) return;

      pokeOnce();
      try { $visibleInput.focus(); } catch (e) {}
    }, delay);
  });
}

// Body scroll lock — while the DooFinder layer is open we don't want
// the page underneath to scroll (touch drags on the gradient backdrop
// were bleeding through to the document, which made it feel like the
// layer was leaky).
//
// Implementation:
//   - On open, snapshot the current inline overflow values on `<html>`
//     and `<body>` into `window.__acDfPrevOverflow`, then force both to
//     `hidden`. We use the documentElement-level lock alongside body
//     because Safari ignores body-only locks when the body is shorter
//     than the viewport.
//   - On every close path, restore from the snapshot and delete it.
//   - The functions are idempotent — `__acDfPrevOverflow` is only
//     captured once until released, so a stray double-call won't
//     "snapshot" the locked state and leave the body permanently
//     hidden.
//
// Caveat: the WP admin bar (logged-in editors) is `position: fixed`
// and isn't affected by body overflow, so its stickiness is unchanged.
// Touch-drag scroll within the layer itself stays functional because
// the lock only sits on documentElement / body, not on inner
// scrollable descendants (`.dfd-content` is `overflow-y: auto`).
function ac_lockBodyScroll() {
  if (window.__acDfPrevOverflow) return; // already locked
  window.__acDfPrevOverflow = {
    html: document.documentElement.style.overflow,
    body: document.body.style.overflow
  };
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
}
function ac_unlockBodyScroll() {
  var prev = window.__acDfPrevOverflow;
  if (!prev) return;
  // Restore the exact inline value (empty string means "remove the
  // override" — that's the desired default for unset inline styles).
  document.documentElement.style.overflow = prev.html || '';
  document.body.style.overflow = prev.body || '';
  delete window.__acDfPrevOverflow;
}
// Expose on window so doofinder.js (which lives in its own module file
// and gets browserified into the same bundle) can call into the same
// lock/unlock primitives from its layer-state observer. Also exposes
// the history helper for the same reason.
window.ac_lockBodyScroll = ac_lockBodyScroll;
window.ac_unlockBodyScroll = ac_unlockBodyScroll;

// History integration — Android pattern: pressing the system / browser
// back button while the search layer is open should close the layer
// rather than navigating away.
//
// Strategy:
//   - On the FIRST open within this page session, push a marker state
//     (`{ acDfOpen: true }`) into history. The URL itself is unchanged.
//   - Track whether we pushed via the module-scoped flag so subsequent
//     open/close cycles don't stack history entries.
//   - A popstate listener watches for the marker to disappear: if the
//     layer is currently open and the new state lacks our marker, the
//     user pressed back — run the close path.
//   - On every close path we own, replace the URL back to a clean
//     `pathname + search` (no hash, no marker) IF we pushed in the
//     first place. Otherwise leave history alone so a deep-link to
//     `/page#fullscreen/...` (DooFinder's own bookmarkable layer state)
//     keeps working.
var ac_dfHistoryPushed = false;
function ac_pushDoofinderHistoryOnce() {
  if (ac_dfHistoryPushed) return;
  try {
    history.pushState({ acDfOpen: true }, '', location.href);
    ac_dfHistoryPushed = true;
  } catch (err) {
    // pushState can throw in privacy modes or with weird URLs — fail
    // silent, the layer still works without the back-button capture.
  }
}
function ac_replaceDoofinderHistoryIfPushed() {
  if (!ac_dfHistoryPushed) {
    // We never pushed — if a DooFinder hash is on the URL (cold reload
    // landed on `/page#fullscreen/...`), the legacy hash cleanup below
    // still applies via the original close handlers.
    return;
  }
  ac_dfHistoryPushed = false;

  // If we're here BECAUSE the popstate listener is already handling a
  // back-button close, the browser has already popped our marker entry
  // for us — there is nothing left to mutate. Calling history.back()
  // in this branch would consume a SECOND entry (skipping past wherever
  // the user was actually trying to go), and replaceState would just
  // resurrect a marker on an entry we no longer own. Leave history
  // alone; this is the "close was itself popstate-triggered" case.
  if (ac_handlingPopstate) {
    return;
  }

  try {
    // User-initiated close (X button, Esc, doofinder observer mirror)
    // while our pushed marker entry is still on top of the stack.
    //
    // Previously this called `history.replaceState(...)`, which only
    // overwrites the CURRENT entry — the marker entry we pushed on open
    // stayed on the stack (now just unmarked). That left an extra,
    // effectively-inert entry between the user and wherever they were
    // before opening search, so the physical back button had to be
    // pressed TWICE: once to land on that leftover entry, once more to
    // actually leave.
    //
    // `history.back()` instead POPS the entry we pushed, moving the
    // user's position back to whatever preceded it — exactly cancelling
    // out the earlier `pushState` from `ac_pushDoofinderHistoryOnce`.
    // One physical back-press then behaves as if the search layer had
    // never touched history at all.
    //
    // back() dispatches `popstate` asynchronously, which re-enters the
    // listener above. By then every caller of this function has already
    // stripped `.is-open` from the form (see the toggle/X/Esc handlers),
    // so the listener's `$openForm.length` guard makes that re-entry a
    // no-op — no double-close, no extra teardown.
    //
    // (The DooFinder `#fullscreen` hash itself is stripped by the
    // callers BEFORE they invoke this function — see the explicit
    // `history.replaceState(null, '', location.pathname + location.search)`
    // calls in the toggle handler and the close-button handler. That
    // cleanup runs on the current entry first, so the back() below pops
    // an already hash-free entry.)
    if (window.history.length > 1) {
      history.back();
    } else {
      // Nothing to go back to (first entry in this tab's session) —
      // back() would leave the site entirely. Fall back to clearing the
      // marker (and hash, if still present) in place.
      history.replaceState(null, '', location.href);
    }
  } catch (err) { /* same fail-silent as above */ }
}
// Expose on window so doofinder.js's observer-driven close path can
// route through the same primitive.
window.ac_replaceDoofinderHistoryIfPushed = ac_replaceDoofinderHistoryIfPushed;

// Module-init popstate listener. The handler is delegated to the same
// close primitives the toggle / close-button / Esc paths already use,
// so we keep one source of truth for "close the layer". A flag on the
// listener (`ac_handlingPopstate`) lets the close primitives know they
// were entered via popstate so they skip the history-replace step that
// would push another entry on the stack.
var ac_handlingPopstate = false;
window.addEventListener('popstate', function (event) {
  // Two conditions must hold:
  //   1. The new state does NOT have our marker — the user navigated
  //      AWAY from the entry we pushed, i.e. they pressed back.
  //   2. The layer is currently open (form has `.is-open`). Otherwise
  //      the popstate is unrelated to our search overlay.
  var hasMarker = event.state && event.state.acDfOpen === true;
  if (hasMarker) return;
  var $openForm = $('.search-form-container.is-open');
  if (!$openForm.length) return;

  // We've left our pushed entry — flag so the close path doesn't try
  // to replaceState again (we're now on the previous history entry,
  // which is the legitimate page state).
  ac_handlingPopstate = true;
  ac_dfHistoryPushed = false;

  window.ac_searchFormUserClosing = true;
  $openForm.removeClass('is-open');
  if (typeof window.ac_teardownDoofinderDialog === 'function') {
    window.ac_teardownDoofinderDialog();
  }
  ac_unlockBodyScroll();
  if (window.ac_syncLayerTop) {
    requestAnimationFrame(window.ac_syncLayerTop);
    setTimeout(window.ac_syncLayerTop, 120);
  }
  setTimeout(function () {
    window.ac_searchFormUserClosing = false;
    ac_handlingPopstate = false;
  }, 400);
});

// Keep the mobile `.search-btn`'s aria-expanded + visual icon/label
// state in sync with `.search-form-container--mobile.is-open`. The
// container can be opened/closed from multiple places (toggle handler,
// X button, Esc handler, popstate, doofinder observer mirror) so we
// watch the class attribute directly rather than patching every site.
// CSS swaps the icon + label off `[aria-expanded="true"]`.
(function () {
  function ac_syncSearchBtnAriaToFormState() {
    var $mobileForm = $('.search-form-container--mobile').first();
    if (!$mobileForm.length) return;
    var isOpen = $mobileForm.hasClass('is-open');
    $('.search-btn').each(function () {
      this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      this.setAttribute('aria-label', isOpen ? 'Close search' : 'Open search');
    });

    // If the form has closed (any path: X button, Esc, popstate, doofinder
    // observer mirror) AND we still have a pending first-input listener
    // from the open path, detach it. The user has dismissed before typing
    // — next open should start a fresh listener.
    if (!isOpen && window.__acDfMobileFirstInputListener && window.__acDfMobileFirstInputTarget) {
      window.__acDfMobileFirstInputTarget.removeEventListener(
        'input',
        window.__acDfMobileFirstInputListener
      );
      window.__acDfMobileFirstInputListener = null;
      window.__acDfMobileFirstInputTarget = null;
    }
  }
  // Run once at boot to align with whatever state the form was rendered in.
  $(function () {
    ac_syncSearchBtnAriaToFormState();
    var formEl = document.querySelector('.search-form-container--mobile');
    if (!formEl) return;
    new MutationObserver(ac_syncSearchBtnAriaToFormState).observe(formEl, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });
})();

// `#search-toggle` (desktop / tablet pill button) AND `.search-btn`
// (mobile nav icon-link) both flip the same container.
//
// Bound directly (not delegated through `document`) because mobile
// Safari can drop the first synthetic click event when it bubbles
// across descendants with `:hover` styles — a delegated handler then
// only fires on the second tap. Direct binding sidesteps that path.
// Dedupe guard: pointerup fires before click on touch, so we only run
// the open/close logic once per gesture.
var ac_lastSearchToggleAt = 0;
function ac_searchToggleHandler(e) {
  e.preventDefault();
  e.stopPropagation();
  var now = Date.now();
  if (now - ac_lastSearchToggleAt < 350) return;
  ac_lastSearchToggleAt = now;
  var $container = ac_findSearchContainer($(this));
  if (!$container.length) return;
  var wasOpen = $container.hasClass('is-open');
  $container.toggleClass('is-open');

  // Mirror the open state onto the triggering button via aria-expanded.
  // CSS uses [aria-expanded="true"] to swap the mobile search-btn's
  // magnifier icon + "Search" label for an X icon + "Close" label,
  // and to update the accessible name for screen readers.
  var willBeOpen = !wasOpen;
  if (this && this.setAttribute) {
    this.setAttribute('aria-expanded', willBeOpen ? 'true' : 'false');
    this.setAttribute(
      'aria-label',
      willBeOpen ? 'Close search' : 'Open search'
    );
  }

  // Recompute the DooFinder layer's top offset so its panel sits
  // directly below the now-visible search bar. Two passes:
  //   1. requestAnimationFrame — runs right before the next paint,
  //      after layout has settled
  //   2. setTimeout(120) — catches any second-frame measurements
  //      (CSS transitions, lazy layout in nested flex contexts)
  if (window.ac_syncLayerTop) {
    requestAnimationFrame(window.ac_syncLayerTop);
    setTimeout(window.ac_syncLayerTop, 120);
  }

  if (!wasOpen) {
    // Capture the pre-open active element BEFORE we move focus to the
    // search input — doofinder.js's setupMobileDialogA11y reads this
    // when the layer mounts (async) and uses it as the restore target
    // on close. By that point document.activeElement has already
    // moved to `.df-search-input`, so we hand it the toggle button
    // explicitly here.
    window.__acDfPrevActive = this;
    // Lock body scroll so dragging on the gradient backdrop doesn't
    // scroll the page underneath. Idempotent — safe to call from any
    // open path. See `ac_lockBodyScroll` above for the implementation.
    ac_lockBodyScroll();
    // Push a history marker so the browser back button closes the
    // layer instead of navigating away. Idempotent: only pushes once
    // per page session — see `ac_pushDoofinderHistoryOnce`.
    ac_pushDoofinderHistoryOnce();
    // After the form is visible: focus the input. On desktop / tablet
    // we then mount DooFinder's layer immediately so the user sees the
    // "Are you looking for…" / "Our Favourites" panels in pre-search.
    //
    // On mobile (`.search-btn` is the trigger) we DEFER mounting the
    // layer until the user types the first non-empty character — per
    // Beckie's brief, the initial mobile state should be just the
    // input bar, not the suggestion / favourites panel.
    //
    // Suppress doofinder.js's syncSearchFormWithLayer mirror while
    // DooFinder mounts/animates the layer. Without this, on a cold
    // first-tap the layer takes a few frames to land `.dfd-fullscreen`
    // on `.dfd-root`, and the mutation observer fires in-between
    // (e.g. when `.dfd-root` is first inserted, or any other class
    // change on it) seeing `layerOpen=false && formOpen=true` — which
    // makes it strip `.is-open` straight off the form. That's exactly
    // why the first tap "did nothing" and a second tap was needed:
    // the second tap toggled a clean state that hadn't yet been
    // clobbered. Holding the suppression for ~1100ms covers the
    // longest poke-retry window in ac_openDoofinderLayer (900ms) plus
    // a little slack for DooFinder's mount animation.
    window.ac_searchFormUserOpening = true;
    setTimeout(function () { window.ac_searchFormUserOpening = false; }, 1100);

    var inputEl = $container.find('.df-search-input').get(0);
    var isMobileTrigger = $(this).is('.search-btn');

    if (isMobileTrigger && inputEl) {
      // Mobile path — focus the input SYNCHRONOUSLY, inside the tap
      // gesture, so iOS raises the soft keyboard. A deferred focus
      // (requestAnimationFrame / setTimeout) runs outside the gesture and
      // iOS silently ignores it: the box appears but the keyboard never
      // opens and the user can't type (Beckie round 3). Don't mount the
      // layer yet — that still waits for the first character below.
      try { inputEl.focus({ preventScroll: true }); } catch (e) { try { inputEl.focus(); } catch (e2) {} }

      // Clean up any stale listener from a previous open→close-without-
      // typing cycle so we don't double-fire on the next open.
      if (window.__acDfMobileFirstInputListener && window.__acDfMobileFirstInputTarget) {
        window.__acDfMobileFirstInputTarget.removeEventListener(
          'input',
          window.__acDfMobileFirstInputListener
        );
      }

      var openLayerOnFirstChar = function () {
        // Ignore the empty-string `input` events that fire when value
        // is cleared (and any spurious dispatches from ac_openDoofinder-
        // Layer's poke trick on the rare race where it fires before
        // detach).
        if (!inputEl.value || inputEl.value.replace(/\s+/g, '').length === 0) return;
        inputEl.removeEventListener('input', openLayerOnFirstChar);
        window.__acDfMobileFirstInputListener = null;
        window.__acDfMobileFirstInputTarget = null;

        // Re-arm the suppression for the deferred mount. Without this,
        // doofinder.js's `syncSearchFormWithLayer` observer can fire
        // mid-mount, see "form open + layer not yet visible" and run
        // the close-path — which tears down dialog ARIA, replaces
        // history, unlocks body scroll, etc. The visible layer that
        // settles a frame or two later then looks rendered but is in
        // a half-torn-down state: pointer-events behaviour breaks
        // because inert / aria-hidden teardown happened on the
        // assumption the layer was closing.
        //
        // The original (desktop) path didn't have this problem because
        // the immediate-mount + 1100ms suppression from the toggle
        // handler covered the whole mount window.
        window.ac_searchFormUserOpening = true;
        setTimeout(function () { window.ac_searchFormUserOpening = false; }, 1100);

        ac_openDoofinderLayer(inputEl);
      };

      inputEl.addEventListener('input', openLayerOnFirstChar);
      window.__acDfMobileFirstInputListener = openLayerOnFirstChar;
      window.__acDfMobileFirstInputTarget = inputEl;
    } else {
      // Desktop / tablet — mount the layer immediately, original behaviour.
      requestAnimationFrame(function () {
        ac_openDoofinderLayer(inputEl);
      });
    }
  } else {
    // Closing the form — block the doofinder.js MutationObserver from
    // re-adding `.is-open` while DooFinder's `dfd-fullscreen` class
    // animates off. Without this, the second toggle click feels dead
    // because the observer instantly mirrors the layer's still-open
    // state back onto the form.
    //
    // We must NOT strip `dfd-fullscreen` ourselves or force-click the
    // native close button — both leave DooFinder's internal LiveView
    // state desynced, which breaks the next open attempt (the layer
    // refuses to mount on the second toggle click).
    //
    // Just suppress the observer for long enough that DooFinder's own
    // hash-driven close (triggered by clearing the hash below) has
    // fully completed.
    window.ac_searchFormUserClosing = true;

    if (location.hash && /fullscreen/i.test(location.hash)) {
      history.replaceState(null, '', location.pathname + location.search);
    }
    // Strip the marker we pushed on open (if any). Also leaves the URL
    // hash-free in the unusual case where DooFinder didn't add a hash
    // (e.g. cold open with an empty query).
    if (typeof window.ac_teardownDoofinderDialog === 'function') {
      window.ac_teardownDoofinderDialog();
    }
    ac_replaceDoofinderHistoryIfPushed();
    ac_unlockBodyScroll();

    // Release the suppress flag once DooFinder's close animation is
    // safely done (~350ms covers the slowest transition we've seen).
    setTimeout(function () { window.ac_searchFormUserClosing = false; }, 400);
  }
}

$(function () {
  // Bind to both pointerup (fires immediately on touch) and click
  // (covers desktop + accessibility tools that synthesise click without
  // pointer events). The dedupe guard inside the handler keeps the two
  // bindings from firing twice for the same tap.
  $('#search-toggle, .search-btn').on('click pointerup', ac_searchToggleHandler);
});

// Note: the in-form submit pill (`.df-search-form .df-search-submit`)
// intentionally has NO click handler — it must submit the form
// natively to `/shop/?s={query}`. Opening the live layer is the job
// of the external toggle (`.df-search-toggle` / `.search-btn`) and
// of typing into the input itself. The Enter-to-submit path is
// reinforced in doofinder.js (it stops DooFinder's keydown listener
// from preventing the form submit).

// Cache + helper: extract DooFinder's per-search-engine layer ID from
// its config script's src — pattern is
//   https://eu1-config.doofinder.com/2.x/<uuid>.js
// and the layer's URL-hash uses the first 4 chars of `<uuid>`. The UUID
// is the only hex segment in the URL so we just grab the last
// path-segment-like hex run before `.js`.
var ac_dfdLayerIdCache = null;
function ac_dfdLayerId() {
  if (ac_dfdLayerIdCache) return ac_dfdLayerIdCache;
  var s = document.querySelector('script[src*="config.doofinder.com"]');
  if (!s) return null;
  // Match the file basename before `.js` — capture the first 4 hex chars.
  var m = s.src.match(/\/([a-f0-9]{8,})/i);
  if (!m) return null;
  ac_dfdLayerIdCache = m[1].substring(0, 4);
  return ac_dfdLayerIdCache;
}

// Explicit close on DooFinder's `.dfd-close-button` only — the
// generic "click anywhere outside" behaviour was killed because it
// inconsistently closed the search bar without closing the layer at
// 990–1439, leaving the layer dangling. Now both closures go through
// the same path: the close X (or our own toggle).
//
// `.dfd-close-button` lives inside `.dfd-root` (body-level sibling),
// so a delegated handler picks it up regardless of when DooFinder
// mounts the chrome.
$(document).on('click', '.dfd-close-button, .dfd-root [class*="close-button"]', function () {
  var $open = $('.search-form-container.is-open');
  if (!$open.length) return;

  // Suppress flag stops the doofinder.js MutationObserver from
  // re-adding `.is-open` mid-animation — without it the form briefly
  // hides then re-shows.
  window.ac_searchFormUserClosing = true;

  $open.removeClass('is-open');

  if (location.hash && /fullscreen/i.test(location.hash)) {
    history.replaceState(null, '', location.pathname + location.search);
  }
  if (typeof window.ac_teardownDoofinderDialog === 'function') {
    window.ac_teardownDoofinderDialog();
  }
  ac_replaceDoofinderHistoryIfPushed();
  ac_unlockBodyScroll();

  setTimeout(function () { window.ac_searchFormUserClosing = false; }, 400);

  if (window.ac_syncLayerTop) {
    requestAnimationFrame(window.ac_syncLayerTop);
    setTimeout(window.ac_syncLayerTop, 120);
  }
});

// Esc closes the open search form.
$(document).on('keydown', function (e) {
  if (e.key !== 'Escape' && e.keyCode !== 27) return;
  var $open = $('.search-form-container.is-open');
  if (!$open.length) return;
  $open.removeClass('is-open');
  if (typeof window.ac_teardownDoofinderDialog === 'function') {
    window.ac_teardownDoofinderDialog();
  }
  ac_replaceDoofinderHistoryIfPushed();
  ac_unlockBodyScroll();
  $('#search-toggle').trigger('focus');
});

// Share button handler — Web Share API with clipboard fallback
$(document).on('click', '.share-btn', function(e) {
    e.preventDefault();
    var url = $(this).data('share-url');
    var title = $(this).data('share-title');
    var btn = $(this);

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function() {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function() {
        var original = btn.html();
        btn.html('<i class="fa-regular fa-check"></i>');
        setTimeout(function() { btn.html(original); }, 2000);
      });
    }
  });

  // #32 — copy the voucher code to the clipboard when the PDP voucher pill
  // (or its copy icon) is clicked. The pill carries data-voucher-code +
  // role="button"/tabindex=0, so we also handle Enter/Space for keyboard
  // users. Mirrors the .share-btn icon-swap feedback pattern above.
  function acityCopyVoucher($pill) {
    var code = $pill.data('voucher-code');
    if (!code || !navigator.clipboard) return;
    navigator.clipboard.writeText(String(code)).then(function() {
      var $icon = $pill.find('.voucher-copy-icon');
      if (!$icon.length) return;
      $icon.removeClass('fa-copy').addClass('fa-check');
      setTimeout(function() { $icon.removeClass('fa-check').addClass('fa-copy'); }, 2000);
    }).catch(function() {});
  }
  $(document).on('click', '.product-pill-box[data-voucher-code]', function() {
    acityCopyVoucher($(this));
  });
  $(document).on('keydown', '.product-pill-box[data-voucher-code]', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      acityCopyVoucher($(this));
    }
  });

  // #3 — price-match modal. Fires when the customer COPIES the product
  // title (copy event only — not on every text highlight, to avoid
  // nagging readers). Once per page load.
  (function () {
    var titleEl = document.querySelector('.ac-product-title');
    var modalEl = document.getElementById('priceMatchModal');
    if (!titleEl || !modalEl) return;
    var shown = false;
    titleEl.addEventListener('copy', function () {
      if (shown) return;
      if (!(window.bootstrap && bootstrap.Modal)) return;
      shown = true;
      bootstrap.Modal.getOrCreateInstance(modalEl).show();
    });
  })();

// Function to get cookie
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

// Function to set cookie
function setCookie(name, value, days = 30) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
}

// Function to get comparison products array from cookie
function getComparisonProducts() {
    const cookie = getCookie('comparison-products');
    if (cookie) {
        try {
            return JSON.parse(decodeURIComponent(cookie));
        } catch (e) {
            return [];
        }
    }
    return [];
}

// Function to save comparison products array to cookie
function saveComparisonProducts(products) {
    const jsonString = JSON.stringify(products);
    setCookie('comparison-products', encodeURIComponent(jsonString));
}

// Function to update compare bar via AJAX
function updateCompareBar() {
    $.ajax({
        url: ajax_object.ajax_url, // WordPress AJAX URL
        type: 'POST',
        data: {
            action: 'update_compare_bar'
        },
        success: function(response) {
            if (response.success) {
                $('#compare-bar').replaceWith(response.data.html);
            }
        },
        error: function() {
            console.error('Failed to update compare bar');
        }
    });
}

// Function to update compare overlay via AJAX
function updateCompareOverlay() {
    // Capture the open state BEFORE the replaceWith — the freshly
    // re-rendered overlay HTML from PHP doesn't carry `.open` (the
    // class is added at runtime by the show/hide handlers), so
    // without re-applying it the overlay would silently close every
    // time we re-render in-place (e.g. on per-product remove).
    var wasOpen = $('#compare-overlay').hasClass('open');

    $.ajax({
        url: ajax_object.ajax_url, // WordPress AJAX URL
        type: 'POST',
        data: {
            action: 'update_compare_overlay'
        },
        success: function(response) {
            if (response.success) {
                $('#compare-overlay').replaceWith(response.data.html);

                if (wasOpen) {
                    $('#compare-overlay').addClass('open');
                }

                // Initialize Trustpilot widgets in the new content
                if (window.Trustpilot) {
                    $('#compare-overlay .trustpilot-widget').each(function() {
                        window.Trustpilot.loadFromElement(this);
                    });
                }

                // Tell multibuy.js to refresh per-product Multibuy badges
                // on the freshly-rendered compare buttons. Without this,
                // the new `.multi-qty` spans render with the static PHP
                // placeholder (0) until the customer clicks one.
                $(document).trigger('tdm:multibuy-counts-need-update');
            }
        },
        error: function() {
            console.error('Failed to update compare overlay');
        }
    });
}

// Handle checkbox click — delegated so dynamically inserted cards
// (DooFinder Live Layer hydration) pick it up without rebinding.
$(document).on('click', '.compare-container input', function() {
    const productValue = $(this).val();
    let comparisonProducts = getComparisonProducts();
    
    if ($(this).is(':checked')) {
        // Add product if not already in array and limit to 4
        if (!comparisonProducts.includes(productValue)) {
            if (comparisonProducts.length >= 4) {
                alert('You can only compare up to 4 products. Please remove one first.');
                $(this).prop('checked', false);
                return;
            }
            comparisonProducts.push(productValue);
        }
    } else {
        // Remove product from array
        comparisonProducts = comparisonProducts.filter(id => id !== productValue);
    }
    
    // Save to cookie
    saveComparisonProducts(comparisonProducts);

    // Update compare bar and overlay via AJAX instead of reload
    updateCompareBar();
    updateCompareOverlay();
});

$(document).on('click', '.clear-compare', function(e) {
  e.preventDefault();

  // Clear the cookie
  setCookie('comparison-products', '[]');

  // Uncheck all product checkboxes
  $('.custom-product-card .checkbox-container input').prop('checked', false);

  if($('#compare-overlay').hasClass('open')) {
    $('#compare-overlay').removeClass('open');
  }

  // Update compare bar and overlay via AJAX
  updateCompareBar();
  updateCompareOverlay();
});

// Per-product remove button inside the compare overlay's column
// header. Drops just one product from the compare cookie (vs the
// `.clear-compare` "Clear All" handler above which wipes everything).
$(document).on('click', '.compare-remove', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var productId = String($(this).data('product-id') || '');
  if (!productId) return;

  // Drop from the cookie state.
  var products = getComparisonProducts().filter(function (id) { return String(id) !== productId; });
  saveComparisonProducts(products);

  // Keep the source card's checkbox in sync — so re-opening a card
  // already in the compare set doesn't show it as still-checked.
  $('.compare-container input[value="' + productId + '"]').prop('checked', false);

  // If we just removed the last product, also collapse the overlay
  // since the compare bar disappears too.
  if (products.length === 0 && $('#compare-overlay').hasClass('open')) {
    $('#compare-overlay').removeClass('open');
  }

  // Refresh the bar + overlay markup from the server so the column
  // for the removed product disappears and `get_common_attributes()`
  // recomputes against the smaller product set.
  updateCompareBar();
  updateCompareOverlay();
});

// Optional: Keep checkboxes checked on page load based on cookie
const savedProducts = getComparisonProducts();
$('.custom-product-card .checkbox-container input').each(function() {
    if (savedProducts.includes($(this).val())) {
        $(this).prop('checked', true);
    }
});

  $(document).on('click', '#compare-table .accordion-control, #compare-table .clickable-title', function() {
    let index = $(this).data('index');
    let $row = $('#comparison-data-row-' + index);
    let $headerRow = $(this).closest('.comparison-header-row');
    let $button = $headerRow.find('.accordion-control');

    let isCurrentlyOpen = $row.hasClass('show');

    if (!isCurrentlyOpen) {
      $row.addClass('show');
      $button.addClass('open').text('Collapse');
    }
    else {
      $row.removeClass('show');
      $button.removeClass('open').text('Expand');
    }
  });

  $(document).on('click', '#compare-overlay .compare-close', function(e) {
    e.preventDefault();
    let $overlay = $(this).closest('#compare-overlay');
    $overlay.toggleClass('open');

    let $bar = $('#compare-bar');
    $bar.removeClass('compare-open');
  })

  $(document).on('click', '#compare-bar #view-compare', function(e) {
    e.preventDefault();
    let $bar = $(this).closest('#compare-bar');

    // Update overlay content before opening
    $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
            action: 'update_compare_overlay'
        },
        success: function(response) {
            if (response.success) {
                $('#compare-overlay').replaceWith(response.data.html);

                // Now open the overlay
                let $overlay = $('#compare-overlay');
                $bar.addClass('compare-open');
                $overlay.addClass('open');

                // Initialize Trustpilot widgets in the new content
                if (window.Trustpilot) {
                    $overlay.find('.trustpilot-widget').each(function() {
                        window.Trustpilot.loadFromElement(this);
                    });
                }

                // Refresh per-product Multibuy badges on the freshly
                // rendered compare buttons. Without this, opening the
                // overlay shows the static `0` placeholder regardless
                // of what's actually in the multibuy cookie.
                $(document).trigger('tdm:multibuy-counts-need-update');
            }
        },
        error: function() {
            console.error('Failed to update compare overlay');
        }
    });
  })

  // Single product sticky sidebar bottom position
  function updateSidebarBottom() {
    if ($(window).width() < 1200 && $('body').hasClass('single-product')) {
      var $sidebar = $('.summary-sidebar');
      var $compareBar = $('#compare-bar');
      if ($compareBar.length && !$compareBar.hasClass('d-none')) {
        $sidebar.css('bottom', $compareBar.outerHeight() + 'px');
      } else {
        $sidebar.css('bottom', '0');
      }
    }
  }
  updateSidebarBottom();
  $(window).on('resize', updateSidebarBottom);
  // Re-check when compare bar updates
  $(document).ajaxComplete(function(_, _, settings) {
    if (settings.data && typeof settings.data === 'string' && settings.data.indexOf('compare') !== -1) {
      setTimeout(updateSidebarBottom, 100);
    }
  });

  $('.summary-sidebar.fixed .close-btn').on('click', function() {
    $(this).removeClass('d-flex').addClass('d-none');
    $(this).closest('.summary-sidebar').removeClass('fixed');
  });

  $('.post-listing select#order-by').on('change', function(e) {
    let form = $('.post-listing form.post-listing-filters');
    if(form.length > 0) {
      let hiddenInput = form.find('input#sort-by');

      // If it doesn't exist, create it
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'sort-by'; // Change this to your desired parameter name
        form.appendChild(hiddenInput);
        hiddenInput = form.find('input[name="sort-by"]');
      }

      // Set the value from the select box
      hiddenInput.val($(this).val());
      console.log("POST SORT ORDER: " + hiddenInput.val());

      // Submit the form
      form.submit();
    }
  });

  const $navTabs = $('#listTab');
  const $prevBtn = $('.nav-scroll-prev');
  const $nextBtn = $('.nav-scroll-next');
  const scrollAmount = 200; // Adjust scroll distance
  
  // Function to update button states
  function updateButtons() {
      const scrollLeft = $navTabs.scrollLeft();
      const maxScroll = $navTabs[0].scrollWidth - $navTabs[0].clientWidth;
      
      // Disable prev button at start
      $prevBtn.prop('disabled', scrollLeft <= 0);
      
      // Disable next button at end
      $nextBtn.prop('disabled', scrollLeft >= maxScroll - 1);
  }
  
  // Scroll previous
  $prevBtn.on('click', function() {
      $navTabs.animate({
          scrollLeft: $navTabs.scrollLeft() - scrollAmount
      }, 300, updateButtons);
  });
  
  // Scroll next
  $nextBtn.on('click', function() {
      $navTabs.animate({
          scrollLeft: $navTabs.scrollLeft() + scrollAmount
      }, 300, updateButtons);
  });
  
  
  if($('#listTab').length > 0) {
    // Update buttons on scroll
    $navTabs.on('scroll', updateButtons);

    // Initial button state
    updateButtons();
  }

  // Login modal removed. The thank-you page handles login/register inline via
  // #order-logging; the My Account page renders the login form directly.

  // Delegate from document so the handler survives AJAX re-renders of the
  // cart / checkout totals block. WooCommerce replaces the whole
  // .woocommerce-coupon-form wrapper after every coupon apply or remove,
  // which previously blew away the direct binding and left the "Have a
  // Voucher Code?" toggle inert until a full page refresh.
  $(document).on('click', '.coupon-toggle', function(){
    // Scope to the form this toggle lives in so multiple cart/checkout
    // surfaces (mobile + desktop) don't fight each other.
    var $form = $(this).closest('form');
    var $coupon = $form.length ? $form.find('.coupon') : $('.coupon');
    $coupon.toggleClass('d-none');
    $(this).toggleClass('active');
  });

  // Prevent Enter key from submitting checkout form in input fields
  if ($('body').hasClass('woocommerce-checkout')) {
    $('form.checkout').on('keydown', 'input:not([type="submit"])', function(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });

    // Pass billing postcode to ncompass postcode form when confirm button is clicked
    $('.delivery-address-confirm').on('click', function() {
      var billingPostcode = $('#billing_postcode').val();
      if (billingPostcode) {
        $('.ncompass-postcode-form input').val(billingPostcode);
      }
    });
  }

  // Category Tabs (specific to #categoryTabs - not deal category tabs)
  function handleTabPanes() {
    if (window.innerWidth < 992) {
      // Remove 'show' and 'active' classes from category tab panes only
      document.querySelectorAll('#categoryTabsContent .tab-pane').forEach(function(pane) {
        pane.classList.remove('show', 'active');
      });

      document.querySelectorAll('#categoryTabs .nav-link').forEach(function(pane) {
        pane.classList.remove('active');
      });

      $('#categoryTabs .nav-link').on('click', function() {
        $('#categoryTabs').addClass('d-none');
        $('#categoryTabsContent .back-btn').removeClass('d-none');
      });

      $('#categoryTabsContent .back-btn').on('click', function() {
        $('#categoryTabs').removeClass('d-none');
        $('#categoryTabsContent .back-btn').addClass('d-none');

        document.querySelectorAll('#categoryTabs .nav-link').forEach(function(pane) {
          pane.classList.remove('active');
        });

        document.querySelectorAll('#categoryTabsContent .tab-pane').forEach(function(pane) {
          pane.classList.remove('show', 'active');
        });
      });
    }
  }

  // Run on page load
  handleTabPanes();

  // Run on window resize
  window.addEventListener('resize', handleTabPanes);

  // Re-init deals carousel slider on tab change
  $('.deal-category-tabs').on('shown.bs.tab', 'button[data-bs-toggle="tab"]', function (e) {
    var targetPane = $($(e.target).data('bs-target'));
    var $slider = targetPane.find('.deals-carousel');

    if ($slider.length && $slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
    }
  });

  // Deal/Promo category tabs prev/next scroll navigation
  function dealCategories() {
    $('.deal-category-tabs-wrapper').each(function() {
      var $wrapper = $(this);
      var $nav = $wrapper.find('.deal-category-tabs-nav');
      var $tabs = $wrapper.find('.deal-category-tabs');
      var $prevBtn = $wrapper.find('.deal-tabs-prev');
      var $nextBtn = $wrapper.find('.deal-tabs-next');
      var scrollAmount = 200;

      function updateDealTabButtons() {
        var scrollLeft = $nav.scrollLeft();
        var maxScroll = $nav[0].scrollWidth - $nav[0].clientWidth;

        var prevDisabled = scrollLeft <= 0;
        var nextDisabled = scrollLeft >= maxScroll - 1;

        $prevBtn.prop('disabled', prevDisabled);
        $nextBtn.prop('disabled', nextDisabled);

        // Center tabs when both arrows are hidden (no overflow)
        if (prevDisabled && nextDisabled) {
          $tabs.addClass('justify-content-center');
        } else {
          $tabs.removeClass('justify-content-center');
        }
      }

      // Use .off() to prevent stacking handlers on resize
      $prevBtn.off('click').on('click', function() {
        $nav.animate({
          scrollLeft: $nav.scrollLeft() - scrollAmount
        }, 300, updateDealTabButtons);
      });

      $nextBtn.off('click').on('click', function() {
        $nav.animate({
          scrollLeft: $nav.scrollLeft() + scrollAmount
        }, 300, updateDealTabButtons);
      });

      $nav.off('scroll').on('scroll', updateDealTabButtons);
      updateDealTabButtons();
    });
  }

  // Shop category nav prev/next scroll navigation
  function shopCategoryNav() {
    $('.shop-category-nav').each(function() {
      var $wrapper = $(this);
      var $nav = $wrapper.find('.shop-category-scroll');
      var $links = $wrapper.find('.shop-category-links');
      var $prevBtn = $wrapper.find('.shop-category-prev');
      var $nextBtn = $wrapper.find('.shop-category-next');
      var scrollAmount = 200;

      function updateButtons() {
        var scrollLeft = $nav.scrollLeft();
        var maxScroll = $nav[0].scrollWidth - $nav[0].clientWidth;

        var prevDisabled = scrollLeft <= 0;
        var nextDisabled = scrollLeft >= maxScroll - 1;

        $prevBtn.prop('disabled', prevDisabled);
        $nextBtn.prop('disabled', nextDisabled);
      }

      $prevBtn.off('click').on('click', function() {
        $nav.animate({
          scrollLeft: $nav.scrollLeft() - scrollAmount
        }, 300, updateButtons);
      });

      $nextBtn.off('click').on('click', function() {
        $nav.animate({
          scrollLeft: $nav.scrollLeft() + scrollAmount
        }, 300, updateButtons);
      });

      $nav.off('scroll').on('scroll', updateButtons);
      updateButtons();
      $wrapper.addClass('js-initialized');
    });
  }

  if($('.gfield').length > 0) {
    $('.gfield_required').text('*');
  }

  // Request Return JS
  function requestReturnForm() {
    var $form = $('.woocommerce-returns-form');

    if (!$form.length) {
      return;
    }

    // Use .data() instead of attr + JSON.parse
    var orderDetails = $form.data('order-details');

    if (!orderDetails) {
      console.log('No order details found');
      return;
    }

    // Field mapping object — selectors target the CSS classes set on form #3
    // (return-first-name, return-last-name, etc).
    var fieldMap = {
      '.return-first-name input': orderDetails.order_first_name,
      '.return-last-name input': orderDetails.order_last_name,
      '.return-address .ginput_address_line_1 input': orderDetails.order_billing_address_1,
      '.return-address .ginput_address_line_2 input': orderDetails.order_billing_address_2,
      '.return-address .ginput_address_city input': orderDetails.order_billing_city,
      '.return-address .ginput_address_state input': orderDetails.order_billing_state,
      '.return-address .ginput_address_zip input': orderDetails.order_billing_postcode,
      '.return-address .ginput_address_country select': orderDetails.order_billing_country,
      '.return-phone input': orderDetails.order_billing_phone,
      '.return-email input': orderDetails.order_billing_email,
      '.return-order-id input': orderDetails.order_id,
      '.return-product-sku input': orderDetails.product_sku
    };

    // Loop through and set values. Do NOT trigger 'change' — these populated
    // fields would otherwise cascade into Gravity Forms' conditional logic.
    $.each(fieldMap, function(selector, value) {
      if (value) { // Only set if value exists
        $form.find(selector).val(value);
      }
    });
  }

  requestReturnForm();

  // Gravity Forms re-renders the form on AJAX validation errors. Re-apply the
  // prefill values whenever GF re-renders so a failed submit doesn't wipe them.
  $(document).on('gform_post_render', function() {
    requestReturnForm();
  });

  // Saved Address — Crafty Clicks postcode lookup wire-up.
  // The plugin's checkout.js auto-binds to WC's native billing_*/shipping_*
  // field IDs. Our Saved Addresses pages use Gravity Form 4, so we mount our
  // own lookup widget that maps to the GF field selectors (ginput_address_*).
  function initSavedAddressPostcodeLookup() {
    var $form = $('.woocommerce-add-address-form, .woocommerce-edit-address-form');
    if (!$form.length || typeof CraftyPostcodeCreate === 'undefined' || typeof _cp_config === 'undefined') {
      return;
    }

    // Avoid double-mounting if the widget is already present (e.g. after a
    // Gravity Forms AJAX re-render).
    if ($form.find('.crafty-saved-address-lookup').length) {
      return;
    }

    var $line1 = $form.find('.ginput_address_line_1 input');
    var $line2 = $form.find('.ginput_address_line_2 input');
    var $city  = $form.find('.ginput_address_city input');
    var $state = $form.find('.ginput_address_state input');
    var $zip   = $form.find('.ginput_address_zip input');
    if (!$line1.length) {
      return;
    }

    // Give the GF address inputs stable IDs the Crafty Clicks instance can
    // target via document.getElementById(). Use unique IDs scoped to this
    // wire-up to avoid clashing with anything else on the page.
    $line1.attr('id', 'crafty-sa-line1');
    $line2.attr('id', 'crafty-sa-line2');
    $city.attr('id', 'crafty-sa-city');
    $state.attr('id', 'crafty-sa-state');
    $zip.attr('id', 'crafty-sa-zip');

    var widget = $(
      '<div class="crafty-saved-address-lookup w-100 mb-4">' +
        '<label for="crafty-sa-search" class="form-label d-block mb-2">Postcode lookup</label>' +
        '<div class="d-flex gap-2 align-items-stretch">' +
          '<input type="text" id="crafty-sa-search" class="form-control flex-grow-1" placeholder="Enter postcode" />' +
          '<button type="button" id="crafty-sa-button" class="gradient-btn text-nowrap flex-shrink-0">' +
            (_cp_config.button_text || 'Find Address') +
          '</button>' +
        '</div>' +
        '<div id="crafty-sa-result" class="mt-2"></div>' +
      '</div>'
    );

    // Mount the widget above the address block at the gfield level so it
    // inherits the full row width, not the narrow inner address-line cell.
    // GF puts each address sub-field inside a span like .address_line_1 /
    // .address-address — those are constrained to a fraction of the row.
    var $addressGfield = $line1.closest('.gfield').first();
    if ($addressGfield.length) {
      $addressGfield.before(widget);
    } else {
      $line1.closest('.gfield, p, div').first().before(widget);
    }

    var cp = CraftyPostcodeCreate();
    cp.set('access_token',     _cp_config.access_token);
    cp.set('result_elem_id',   'crafty-sa-result');
    cp.set('form',             '');
    cp.set('busy_img_url',     typeof _cp_busy_img_url !== 'undefined' ? _cp_busy_img_url : '');
    cp.set('elem_street1',     'crafty-sa-line1');
    cp.set('elem_street2',     'crafty-sa-line2');
    cp.set('elem_town',        'crafty-sa-city');
    cp.set('elem_county',      'crafty-sa-state');
    cp.set('elem_postcode',    'crafty-sa-zip');
    cp.set('traditional_county', _cp_config.counties);
    cp.set('msg1',             _cp_config.msg1);
    cp.set('err_msg1',         _cp_config.err_msg1);
    cp.set('err_msg2',         _cp_config.err_msg2);
    cp.set('err_msg3',         _cp_config.err_msg3);
    cp.set('err_msg4',         _cp_config.err_msg4);
    cp.set('res_autoselect',   _cp_config.res_autoselect);

    // After Crafty Clicks fills the GF inputs, fire 'change' so any GF
    // conditional logic / state-tracking picks up the new values.
    cp.set('on_result_selected', function() {
      [$line1, $line2, $city, $state, $zip].forEach(function($el) {
        $el.trigger('change');
      });
    });

    widget.find('#crafty-sa-button').on('click', function(e) {
      e.preventDefault();
      // Mirror the search input value into the hidden postcode element the
      // plugin reads from, then run the lookup.
      var searchVal = widget.find('#crafty-sa-search').val();
      $zip.val(searchVal);
      cp.doLookup();
    });

    // Allow Enter inside the search input to trigger lookup.
    widget.find('#crafty-sa-search').on('keypress', function(e) {
      if (e.which === 13) {
        e.preventDefault();
        widget.find('#crafty-sa-button').trigger('click');
      }
    });
  }

  if($('.woocommerce-add-address-form, .woocommerce-edit-address-form').length > 0) {
    // Run after GF has rendered the form.
    initSavedAddressPostcodeLookup();
    $(document).on('gform_post_render', function() {
      initSavedAddressPostcodeLookup();
    });
  }

  // Edit Address JS
  function editAddressForm() {
    var $form = $('.woocommerce-edit-address-form');

    // Use .data() instead of attr + JSON.parse
    var editAddress = $form.data('edit-address');

    if (!editAddress) {
      console.log('No order details found');
      return;
    }

    // Field mapping object
    var fieldMap = {
      '.address-title input': editAddress.title,
      '.address-firstname input': editAddress.first_name,
      '.address-lastname input': editAddress.last_name,
      '.address-address .ginput_address_line_1 input': editAddress.address_1,
      '.address-address .ginput_address_line_2 input': editAddress.address_2,
      '.address-address .ginput_address_city input': editAddress.city,
      '.address-address .ginput_address_state input': editAddress.state,
      '.address-address .ginput_address_zip input': editAddress.postcode,
      '.address-address .ginput_address_country select': editAddress.country,
      '.address-phone input': editAddress.phone,
      '.address-email input': editAddress.email,
      '.address-w3w input': editAddress.what3words,
      '.address-default input': editAddress.default_address,
      '.address-user-id input': editAddress.user_id,
      '.address-id input': editAddress.id
    };

    // Loop through and set values
    $.each(fieldMap, function(selector, value) {
      if (value !== undefined && value !== null && value !== '') { // Only set if value exists
        // Handle checkbox for default address
        if (selector === '.address-default input') {
          if (value == 1) {
            $form.find(selector).prop('checked', true).trigger('change');
          } else {
            $form.find(selector).prop('checked', false).trigger('change');
          }
        } else {
          $form.find(selector).val(value).trigger('change');
        }
      }
    });
  }

  if($('.woocommerce-edit-address-form').length > 0) {
    editAddressForm();
  }

  // Add Address JS
  function addressForm() {
    var $form = $('.woocommerce-add-address-form');

    var userId = $form.attr('data-user-id');
    var addressId = $form.attr('data-address-id');
    
    if (!userId) {
      console.log('No user id found');
      return;
    }

    $form.find('.address-user-id input').val(userId).trigger('change');

    if(addressId) {
      $form.find('.address-id input').val(addressId).trigger('change');
    }
  }

  if($('.woocommerce-add-address-form').length > 0) {
    addressForm();
  }

  // Bulk-remove OOS items (spec #7) — wired on cart + checkout pages.
  // The notice + button is rendered server-side via
  // acity_render_oos_block_notice() whenever the cart contains an
  // outofstock / onbackorder line. Clicking the button posts to the
  // acity_remove_oos_items AJAX endpoint, then reloads the page to
  // re-render the cart in its cleared state.
  $(document).on('click', '.acity-remove-oos-items', function(e) {
    e.preventDefault();
    var $btn = $(this);
    if (typeof window.acityOosRemove === 'undefined') {
      return;
    }
    $btn.prop('disabled', true).addClass('is-loading');
    $.ajax({
      url: window.acityOosRemove.ajax_url,
      type: 'POST',
      data: {
        action: 'acity_remove_oos_items',
        nonce: window.acityOosRemove.nonce
      },
      success: function() {
        // Refresh the page so cart + checkout templates re-render
        // without the OOS lines (and the proceed/Continue buttons
        // are re-enabled).
        location.reload();
      },
      error: function() {
        $btn.prop('disabled', false).removeClass('is-loading');
        alert('Could not remove items awaiting stock. Please try again.');
      }
    });
  });

  // Previously (spec #7) this disabled every "Continue" button on
  // cart + checkout whenever `.acity-oos-block-notice` was present, to
  // force the customer to clear OOS items before advancing. The
  // policy has since flipped: OOS items are purchasable, the notice
  // is now informational, and the matching server-side block in
  // acity_block_checkout_with_oos has been retired (see
  // inc/woocommerce-functions.php). Leaving the JS disable in place
  // would re-introduce the block at the UI layer, making step 1's
  // Continue button look stuck. Intentionally removed.

  // Update Default Address
  $(document).on('click', '.default-update-btn', function(e) {
    e.preventDefault();
    
    const addressId = $(this).data('default-update');
    const userId = $(this).data('user-id');
    const button = $(this);
    
    // Optional: Disable button during request
    button.prop('disabled', true);
    
    $.ajax({
      url: ajax_object.ajax_url, // WordPress AJAX URL
      type: 'POST',
      data: {
        action: 'update_default_address',
        address_id: addressId,
        user_id: userId,
        nonce: ajax_object.update_default_address_nonce // Security nonce
      },
      success: function(response) {
        if (response.success) {
          console.log('Default address updated');

          // Reload the page to show updated layout
          location.reload();
        } else {
          console.error('Error:', response.data.message);
          alert('Error updating default address');
        }
      },
      error: function(xhr, status, error) {
        console.error('AJAX Error:', error);
        alert('Failed to update default address');
      },
      complete: function() {
        button.prop('disabled', false);
      }
    });
  });

  // Delete Address
  $(document).on('click', '.delete-address-btn', function(e) {
    e.preventDefault();
    
    const rowId = $(this).data('delete-id');
    const userId = $(this).data('user-id');
    const button = $(this);
    
    // Optional: Disable button during request
    button.prop('disabled', true);
    
    $.ajax({
      url: ajax_object.ajax_url, // WordPress AJAX URL
      type: 'POST',
      data: {
        action: 'delete_user_address',
        row_id: rowId,
        user_id: userId,
        nonce: ajax_object.delete_user_address_nonce // Security nonce
      },
      success: function(response) {
        if (response.success) {
          console.log('Address deleted');

          // Reload the page to show updated layout
          location.reload();
        } else {
          console.error('Error:', response.data.message);
          alert('Error updating default address');
        }
      },
      error: function(xhr, status, error) {
        console.error('AJAX Error:', error);
        alert('Failed to update default address');
      },
      complete: function() {
        button.prop('disabled', false);
      }
    });
  });

  // Remove Biometic 2FA Option
  if($('.woocommerce-security-form #row-webauthn').length > 0) {
    $('.woocommerce-security-form #row-webauthn').remove();
  }

  // Mobile Account Navigation
  $('#woocommerce-account-nav-toggle').on('click', function() {
    $('.woocommerce-account-nav').toggleClass('d-none');
  });

  // Defer Trustpilot widget loading until after critical JS (sliders etc.) has initialized
  function loadTrustpilot() {
    if (document.querySelector('.trustpilot-widget')) {
      var script = document.createElement('script');
      script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }

  // Feefo Product Stars — same deferred, only-if-present loading as Trustpilot
  // above. Feefo's script scans the DOM for .feefo-product-stars-widget shells
  // (see ac_render_product_feefo() in inc/_feefo-widgets.php) and hydrates them.
  //
  // Retry once if the Feefo script itself fails to load, so a single dropped
  // request doesn't leave every stars widget on the page blank until the next
  // page view (part of the "reviews sometimes don't show" report). This only
  // covers the script failing to load; the per-product hydration after that is
  // Feefo's own, and a product with no reviews is legitimately empty.
  function loadFeefo() {
    if (!document.querySelector('.feefo-product-stars-widget')) return;
    var attempt = function (retriesLeft) {
      var script = document.createElement('script');
      script.src = 'https://api.feefo.com/api/javascript/appliance-city-ltd';
      script.async = true;
      script.onerror = function () {
        script.remove();
        if (retriesLeft > 0) {
          window.setTimeout(function () { attempt(retriesLeft - 1); }, 2000);
        }
      };
      document.body.appendChild(script);
    };
    attempt(1);
  }

  // Defer the Feefo script (and its per-shell fetches) on EVERY page until the
  // first stars shell approaches the viewport, not just the homepage. Feefo
  // hydrates all shells at once when its script loads, so on shell-heavy
  // templates (hub guides carry ~59 shells / ~111 api.feefo.com fetches,
  // category listings similar) this lifts that whole burst out of initial
  // load. Shells already in or near the viewport (e.g. the PDP stars) still
  // fire near-immediately, because the observer reports them intersecting on
  // its first callback; only below-the-fold shells actually wait. A scroll or
  // touch fires it regardless. (Neil, Aug 2026 — widened from homepage-only.)
  var feefoFirstShell = document.querySelector('.feefo-product-stars-widget');
  var feefoLazy = feefoFirstShell && 'IntersectionObserver' in window;

  if (feefoLazy) {
    var feefoFired = false;
    var fireFeefo = function () {
      if (feefoFired) return;
      feefoFired = true;
      loadFeefo();
    };
    var feefoIO = new IntersectionObserver(function (entries) {
      for (var fi = 0; fi < entries.length; fi++) {
        if (entries[fi].isIntersecting) {
          feefoIO.disconnect();
          fireFeefo();
          break;
        }
      }
    }, { rootMargin: '400px 0px' });
    feefoIO.observe(feefoFirstShell);
    // A scroll or touch means the shopper is heading for the carousels —
    // don't make them wait on the observer margin.
    window.addEventListener('scroll', fireFeefo, { passive: true, once: true });
    window.addEventListener('touchstart', fireFeefo, { passive: true, once: true });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadTrustpilot);
    if (!feefoLazy) requestIdleCallback(loadFeefo);
  } else {
    setTimeout(loadTrustpilot, 100);
    if (!feefoLazy) setTimeout(loadFeefo, 100);
  }

});

/**
 * @name check_scroll
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
**/
let check_scroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
  }
};

/**
 * @name magnific_init
 * @description initialise the Magnific Popups for the page
**/
let magnific_init = () => {
  if($('.magnific').length > 0){
    $('.magnific').magnificPopup({
      type:'image',
      gallery: {
        enabled: true,
      }
    });
  }
};

/**
 * @name mega_menu
 * @description handles the offset for mega menus
**/
let mega_menu = () => {
  if ($('.mega-menu').length) {
    setTimeout(function() {
      let header_height = $('#header').outerHeight();

      if($('body').hasClass('logged-in') && $('body').hasClass('admin-bar')) {
        header_height = header_height + 32;
      }

      $('.mega-menu').css('top', header_height + 'px');

      // Expose the header offset so the mega-menu's gradient ::before
      // can start at the bottom of the header rather than at viewport
      // top. The pseudo-element is `position: fixed` to extend below the
      // menu down to the viewport bottom, but without this var it would
      // also cover the header itself. CSS reads
      // `top: var(--ac-header-offset, 0px)` — see styles.scss.
      document.documentElement.style.setProperty('--ac-header-offset', header_height + 'px');
    }, 500);
  }

  if ($('.submenu-brands').length) {
    setTimeout(function() {
      let header_height = $('#header').outerHeight();

      if($('body').hasClass('logged-in') && $('body').hasClass('admin-bar')) {
        header_height = header_height + 32;
      }

      $('.submenu-brands').css('top', header_height + 'px');
    }, 500);
  }
}

/**
 * @name menu_toggle
 * @description handles opening and closing of the mobile menu on the site
 * @param {*} open flag indicating whether or not the menu is in an open state
**/
var open = false;
let menu_toggle = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile > .menu-inner").toggleClass("open", open);
  $(".wcc-btn-revisit-wrapper").toggleClass("d-none", open);
  // Hide product gallery buttons when nav menu is open to prevent z-index overlap
  $(".gallery-actions, .magnific, .btn-play-video, .gallery-nav").toggleClass("nav-open-hidden", open);
};

/**
 * @name slick_init
 * @description initialise the Slick sliders for the page (docs: https://kenwheeler.github.io/slick/)
**/
let slick_init = () => {
  // $(".carousel__<name>").slick({
  //   dots: false,
  //   arrows: false,
  //   autoplay: true,
  //   autoplaySpeed: 4000,
  //   slidesToScroll: 1,
  //   slidesToShow: 1,
  // });

  $(".footer-links-slider").slick({
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
  });

  $(".knowledge-slider").slick({
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
    ],
  });

  $(".history-block-carousel").slick({
    dots: true,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1439,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      }
    ],
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-caret-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-caret-left"></i></button>'
  });

  $(".related-posts-carousel").slick({
    dots: true,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ],
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-caret-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-caret-left"></i></button>'
  });

  $(".hub-content-carousel").slick({
    dots: false,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ],
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-caret-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-caret-left"></i></button>'
  });

  $(".deals-carousel").slick({
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1339,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ],
  });

  $(".recommended-slider").slick({
    dots: true,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1339,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ],
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>'
  });

  $(".partners-carousel, .brands-carousel").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 2,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1699,
        settings: {
          slidesToShow: 8
        }
      },
      {
        breakpoint: 1439,
        settings: {
          slidesToShow: 7
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 524,
        settings: {
          slidesToShow: 3
        }
      }
    ],
  });

  $('.fbt-card-slider').slick({
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>'
  })

  // Desktop deal line-up. Up to three cards fit on a row, so a deal with four
  // or more wrapped onto a second line (Monday 12658367314). Carousel those so
  // the line-up stays on one row with an arrow either side. Fewer than four
  // still fits, so it is left as the plain flex-wrap layout.
  //
  // Slick's `unslick` is one-way: once torn down on a narrow viewport it will
  // not rebuild itself on the way back up. That matters more than it looks,
  // because an iPad crosses this breakpoint just by being rotated (768 portrait
  // to 1024 landscape). So init is a named function and a debounced resize
  // handler re-runs it whenever the viewport comes back above md.
  function initFbtDealCarousels() {
    if (window.innerWidth < 768) { return; }

    $('.fbt-card-wrapper').each(function () {
      var $wrapper = $(this);
      if ($wrapper.children('.fbt-card').length < 4) { return; }
      if ($wrapper.hasClass('slick-initialized')) { return; }

      $wrapper.addClass('fbt-card-wrapper--carousel').slick({
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
        prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
        responsive: [
          { breakpoint: 1400, settings: { slidesToShow: 2 } },
          // Below md the wrapper is display:none and .fbt-card-slider takes
          // over, so tear the carousel down rather than leave a zero-width
          // track. initFbtDealCarousels() puts it back on the way up.
          { breakpoint: 768,  settings: 'unslick' }
        ]
      });
    });
  }

  initFbtDealCarousels();

  var fbtResizeTimer = null;
  $(window).on('resize.fbtDeals', function () {
    clearTimeout(fbtResizeTimer);
    fbtResizeTimer = setTimeout(initFbtDealCarousels, 200);
  });
};

function noticeBanner(speed, selector) {
  $(selector).each(function () {
    const $track = $(this);
    const $originalSlides = $track.children();
    const originalCount = $originalSlides.length;

    // Clone slides in original order to reach at least 4
    if (originalCount < 4) {
      const slidesNeeded = 4 - originalCount;
      for (let i = 0; i < slidesNeeded; i++) {
        const indexToClone = i % originalCount;
        $track.append($originalSlides.eq(indexToClone).clone());
      }
    }

    // Duplicate all slides to enable infinite loop
    $track.append($track.children().clone());

    let position = 0;
    let lastTimestamp = null;

    function animate(timestamp) {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const delta = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      position -= delta * speed;

      const $firstSlide = $track.children().first();
      const firstSlideWidth = $firstSlide.outerWidth(true);

      // Shift first slide to the end once fully out of view
      if (-position >= firstSlideWidth) {
        $firstSlide.appendTo($track);
        position += firstSlideWidth;
      }

      $track.css('transform', `translateX(${position}px)`);
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  });
} 